
import { defineComponent, PropType, reactive } from 'vue'

// types
import { OneCT } from '@/core/types/one_c.types'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisations
import { onec } from '@/core/realisations/onec.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    props: {
        item: {
            type: Object as PropType<OneCT>,
            required: true,
        },
    },
    components: {
        'the-button': TheButton,
    },
    setup(props) {
        const state = reactive({
            is_loading: false,
        })

        const notifications = useNotifications()

        const resend = async () => {
            try {
                state.is_loading = true
                await onec.resend(props.item.id)

                notifications.notify({ title: 'Накладная добавлена в заказ!', type: 'success' })
            } catch (error) {
                notifications.notify({
                    title: 'При переотправке заказа произошла ошибка',
                    type: 'danger',
                })
            } finally {
                state.is_loading = false
            }
        }

        return { state, resend }
    },
})
